import { InfoBlockContainer } from './InfoBlockContainer';
import { InfoBlockItem } from './InfoBlockItem';

export const InfoBlock = {
  Item: InfoBlockItem,
  Container: InfoBlockContainer,
} as const;
